module.exports = __webpack_public_path__ + "img/transBackArrow.f9c7ea4c.svg";